import { render, staticRenderFns } from "./ImportDialog.vue?vue&type=template&id=37c94576&scoped=true&"
import script from "./ImportDialog.vue?vue&type=script&lang=js&"
export * from "./ImportDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImportDialog.vue?vue&type=style&index=0&id=37c94576&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c94576",
  null
  
)

export default component.exports